import React from "react";
import NewTimeAssessmentScreen from "./timeAssessment/TimeAssessmentScreen";

// This is a wrapper component that uses the new cinematic experience
const TimeAssessmentScreen = (props) => {
  return <NewTimeAssessmentScreen {...props} />;
};

export default TimeAssessmentScreen;
